
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]/community/[communityId]",
      function () {
        return require("private-next-pages/[publicId]/community/[communityId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[publicId]/community/[communityId]"])
      });
    }
  